import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import WifiIcon from '@mui/icons-material/Wifi';
import CellTowerIcon from '@mui/icons-material/CellTower';
import { motion } from 'framer-motion';

interface ConnectivityOptionCardProps {
  label: 'Wi-Fi' | 'Wi-Fi + Cellular';
  selected: boolean;
  onClick: () => void;
  index: number;
}

export default function ConnectivityOptionCard({ label, selected, onClick, index }: ConnectivityOptionCardProps) {
  const isWifi = label === 'Wi-Fi';
  const Icon = isWifi ? WifiIcon : CellTowerIcon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.08 }}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <Card
        role="radio"
        aria-checked={selected}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        }}
        onClick={onClick}
        sx={{
          cursor: 'pointer',
          height: '100%',
          border: '2px solid transparent',
          borderRadius: 4,
          position: 'relative',
          zIndex: 1,
          marginTop: 1,
          marginBottom: 1,
          background: selected
            ? 'linear-gradient(white, white) padding-box, linear-gradient(135deg, #0ea5e9, #8b5cf6) border-box'
            : 'linear-gradient(white, white) padding-box, linear-gradient(135deg, rgba(0,0,0,0.08), rgba(0,0,0,0.08)) border-box',
          transition: 'all 0.18s ease-in-out',
          minWidth: 200,
          scrollSnapAlign: 'start',
          // 컨테이너 경계에서 hover scale로 인해 테두리가 잘리지 않도록
          transform: 'translateZ(0)',
          willChange: 'transform',
          outline: '2px solid transparent',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: selected
              ? '0 24px 48px rgba(14, 165, 233, 0.18), 0 12px 24px rgba(139, 92, 246, 0.12)'
              : '0 24px 48px rgba(0,0,0,0.08), 0 12px 24px rgba(0,0,0,0.06)'
          }
        }}
      >
        <CardContent sx={{ p: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{
            width: 28, height: 28, borderRadius: 2,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: selected ? 'rgba(14,165,233,0.08)' : 'rgba(99,102,241,0.06)',
            border: selected ? '1px solid rgba(14,165,233,0.4)' : '1px solid rgba(99,102,241,0.2)'
          }}>
            <Icon sx={{ color: selected ? '#0ea5e9' : '#6366f1', fontSize: 18 }} />
          </Box>
          <Typography sx={{ 
            fontWeight: selected ? 600 : 500, 
            color: selected ? '#0ea5e9' : '#1f2937',
            whiteSpace: 'nowrap',
            wordBreak: 'keep-all',
            lineHeight: 1
          }}>
            {isWifi ? 'Wi‑Fi 모델' : 'Wi‑Fi + Cellular'}
          </Typography>
        </CardContent>
      </Card>
    </motion.div>
  );
}


